import { OutboundTrackingEventData } from '../../../../analytics/event-tracking/trackOutboundLinkClick';
import { PartnerBannerVariant } from '../subcomponents/GovernmentDataPartnerBannerWithVariant';

export const getGovernmentDataPartnerBannerTracking = (
  experimentId: string,
  experimentVariation: string,
  click_url: string,
  state: string | null,
  partnerBannerVariant: PartnerBannerVariant,
): { outboundTracking: OutboundTrackingEventData } => {
  return {
    outboundTracking: {
      data: {
        click_url,
        event_name: 'pca_outbound_link_click',
        type: `${experimentId}_cta_${experimentVariation}`,
        name: 'allianz_banner',
        context: [
          {
            key: 'state',
            value: state ? state : '',
          },
          {
            key: 'partner_banner_variant',
            value: partnerBannerVariant,
          },
        ],
      },
      schema: 'iglu:au.com.property/pca_outbound_link_click/jsonschema/1-0-1',
    },
  };
};
